import { Spinner } from "./spinner";

export default function BaseLoadingSpinner() {
    return (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <Spinner className="size-20 text-gray-300">
                <span className="text-lg text-gray-800 animate-pulse font-medium">
                    Just a moment, loading in progress.
                </span>
            </Spinner>
        </div>
    );
}
